import JSON5 from 'json5'
import { GCLASSROOM, GCLASSROOM_STUDENT_WORK } from '@mote/helpers/constants'
import { getApplicationKey, getApplicationView } from '@mote/helpers/extension'

export interface ClassroomInfo {
  assignmentName?: string
  className?: string
  studentName?: string
}

export function getBasicClassroomInfo(): ClassroomInfo {
  if (getApplicationKey() !== GCLASSROOM) {
    return {}
  }

  const isStudentWorkView = getApplicationView() === GCLASSROOM_STUDENT_WORK

  try {
    return {
      className: getClassName(isStudentWorkView),
      studentName: getStudentName(isStudentWorkView),
      assignmentName: getAssignmentName(isStudentWorkView)
    }
  } catch {
    return {}
  }
}

export function isClassRoomInfoValid(classroomInfo: ClassroomInfo): boolean {
  return (
    Object.keys(classroomInfo).length === 3 &&
    Object.values(classroomInfo).every(Boolean)
  )
}

function getAssignmentName(isStudentWorkView: boolean) {
  let title = document.title.trim()

  if (isStudentWorkView) {
    return title
  }

  /*
   * Fallback method to acquire assignment name
   *
   * */
  if (!title) {
    const header = document.querySelector('header[role="banner"]')
    if (header) {
      title =
        header.querySelector('[role="heading"]')?.textContent?.trim() || ''
    }
  }

  return title
}

function getClassName(isStudentWorkView: boolean) {
  if (isStudentWorkView) {
    return document.querySelector('nav a span')?.textContent?.trim() || ''
  }

  const scripts = document.querySelectorAll('script')

  const targetScript = Array.from(scripts).find(e =>
    e.outerHTML.includes('"classroom"')
  )

  if (!targetScript) {
    return ''
  }

  const scriptContents = targetScript.innerHTML
  const firstBracket = scriptContents.indexOf('{')
  const lastBracket = scriptContents.lastIndexOf('}')
  const rawData = scriptContents.substring(firstBracket, lastBracket + 1)
  let className = ''

  try {
    const dataJSON = JSON5.parse(rawData)
    className = dataJSON.data[0][2].trim()
  } catch {}

  return className.trim()
}

function getStudentName(isStudentWorkView: boolean) {
  if (isStudentWorkView) {
    const pathname = new URL(document.URL).pathname.split('/')
    const referenceIndex = pathname.indexOf('student')
    const studentId = pathname[referenceIndex + 1]

    return (
      Array.from(
        document.querySelectorAll('[href]') as NodeListOf<HTMLAnchorElement>
      )
        .filter(item => item.href.includes(studentId))
        .find(item => !item.children.length)
        ?.textContent?.trim() || ''
    )
  }

  const wrapper = document
    .querySelector('div[guidedhelpid="submissionSelectorGH"]')
    ?.querySelector('div[aria-checked="true"]')
  let studentName = ''

  if (wrapper) {
    const avatar = wrapper.querySelector('img')
    studentName = avatar?.nextElementSibling?.textContent || ''
  }

  /*
   * Fallback method to acquire student name
   *
   * */
  if (!studentName) {
    const parentElements = Array.from(
      document.querySelectorAll('c-wiz')
    ).filter(node => Boolean(node.querySelector('div[aria-checked="true"]')))

    for (const parent of parentElements) {
      const checkedElement = parent.querySelector('div[aria-checked="true"]')

      if (checkedElement) {
        const avatar = checkedElement.querySelector('img')
        if (avatar && avatar.nextElementSibling) {
          studentName = avatar.nextElementSibling.textContent || ''
          break
        }
      }
    }
  }

  return studentName.trim()
}
